export const IMG_SIZE = 5*1024*1024;//图片大小5M